<template>
  <div>
    <!-- Help Button -->
    <b-button 
      variant="primary"
      size="sm" 
      class="d-flex align-items-center"
      @click="isOpen = true"
    >
      <b-icon-question-circle class="mr-1"></b-icon-question-circle>
      Help
    </b-button>
    
    <!-- Help Modal -->
    <b-modal
      v-model="localIsOpen"
      title="Image Editor Help"
      size="lg"
      header-bg-variant="light"
      @hidden="closeModal"
    >
      <!-- Modal Content -->
      <div class="modal-body-scroll" style="max-height: 70vh; overflow-y: auto;">
        <div class="mb-4">
          <h5 class="font-weight-bold mb-2">Getting Started</h5>
          <p>
            Upload an image by clicking the upload button or drag and drop an image into the designated area.
            Once uploaded, you can crop your image if needed before customizing it.
          </p>
        </div>
        
        <div class="mb-4">
          <h5 class="font-weight-bold mb-2">Adding Text Overlay</h5>
          <p>
            Add text to your image using the text overlay options. You can:
          </p>
          <ul class="pl-4 mt-2">
            <li>Enter your desired text</li>
            <li>Adjust the font size using the slider</li>
            <li>Change the overlay style (white, translucent, or branded)</li>
            <li>Select different shapes for your text background</li>
            <li>Choose a brand color (when using branded style)</li>
          </ul>
        </div>
        
        <div class="mb-4">
          <h5 class="font-weight-bold mb-2">Positioning and Rotation</h5>
          <p>
            Position your text overlay by dragging it around the image. Use the rotation slider to adjust the angle of your text.
          </p>
        </div>
        
        <div class="mb-4">
          <h5 class="font-weight-bold mb-2">Animation Options</h5>
          <p>
            Make your image dynamic by enabling animations. Choose from:
          </p>
          <ul class="pl-4 mt-2">
            <li>Bounce - Makes your overlay bounce into view</li>
            <li>Fade - Fades your overlay in gradually</li>
            <li>Rotate - Spins your overlay into position</li>
            <li>Pulse - Creates a pulsing effect</li>
            <li>Typewriter - Types your text letter by letter</li>
          </ul>
          <p class="mt-2">
            Adjust the animation speed to slow, medium, or fast as desired.
          </p>
        </div>
        
        <div class="mb-4">
          <h5 class="font-weight-bold mb-2">Personalization</h5>
          <p>
            Use [FirstName] in your text to create personalized messages. When sending via email or text, 
            this placeholder will be replaced with the recipient's name.
          </p>
        </div>
        
        <div class="mb-4">
          <h5 class="font-weight-bold mb-2">Saving and Sharing</h5>
          <p>
            Save your image to use it again later. Share your creation via:
          </p>
          <ul class="pl-4 mt-2">
            <li>Email - Send your image in an email message</li>
            <li>Text Message - Send your image via SMS</li>
            <li>Download - Save your image to your device</li>
          </ul>
        </div>
      </div>
      
      <template v-slot:modal-footer>
        <b-button 
          variant="primary" 
          @click="closeModal"
        >
          Close
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { 
  BButton, 
  BModal, 
  BIconQuestionCircle 
} from 'bootstrap-vue';

export default {
  name: 'HelpModal',
  components: {
    BButton,
    BModal,
    BIconQuestionCircle
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      localIsOpen: this.isOpen
    };
  },
  watch: {
    isOpen(newVal) {
      this.localIsOpen = newVal;
    },
    localIsOpen(newVal) {
      if (!newVal && this.isOpen) {
        this.onClose();
      }
    }
  },
  methods: {
    closeModal() {
      this.localIsOpen = false;
      this.onClose();
    }
  }
};
</script>

<style scoped>
.modal-body-scroll::-webkit-scrollbar {
  width: 6px;
}

.modal-body-scroll::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.modal-body-scroll::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.modal-body-scroll::-webkit-scrollbar-thumb:hover {
  background: #9c9c9c;
}
</style>